import React from 'react';
import * as styles from './AccordionHeader.module.scss';

type Props = {
  children: JSX.Element | JSX.Element[] | string;
  className?: string;
};

export const AccordionControls = ({ children, className = '' }: Props) => {
  const classes = [styles.AccordionControls];
  if (className) classes.push(className);
  // This is wrapped in a span instead of a div to prevent
  // triggering the focus ring on the accordion group as it
  // uses a has:() selector
  return <span className={classes.join(' ')}>{children}</span>;
};
